/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';
import { OverviewRiskItem } from 'dashboard/types';

export function useOverviewRisks(queryParams: string) {
  return useQuery<OverviewRiskItem[]>({
    queryKey: [APIKey.OVERVIEW_RISKS, queryParams],
    queryFn: () => baseFetcher(`${apiRoutes.overviewRisks()}?${queryParams}`),
  });
}
